// profile option : KEIKO, AP_KEIKO, SHUCHI, JOUKI, default(DEV)
// import React from 'react';
import {Image} from 'react-bootstrap';
import {getSettingList} from './frontendSettingUtil.js';

// ****************
// **** CONFIG ****
// ****************
let CONFIG = {};

// set server url
if (process.env.REACT_APP_BACKEND_SERVERURL) {
  CONFIG.BACKEND_SERVERURL = process.env.REACT_APP_BACKEND_SERVERURL;
} else {
  CONFIG.BACKEND_SERVERURL = window.location.origin;
}
CONFIG.AUTH_SERVERURL = '';

// base url
if (process.env.REACT_APP_SERVERURL) {
  CONFIG.SERVERURL = process.env.REACT_APP_SERVERURL;
} else {
  CONFIG.SERVERURL = CONFIG.BACKEND_SERVERURL + '/qa';
}

// お問い合わせ画面のURL
CONFIG.INQUIRY_URL = CONFIG.BACKEND_SERVERURL + '/qa/inquiry/create';

function confidenceMeasureLogicB(results) {
  // return True if confident

  //let scoreFirstSecondDiffThreshold = 0.4;

  // スコアだけを全QA分抽出する処理。デバッグ用。
  //let scores = results.map( function(element) {
  //  return element.score;
  //});

  try {
    // 解が1つも無いなら「自信なし」
    if (results.length < 1) {
      return false;
    }
    // 解が1個ならscoreに関係なく「自信あり」
    if (results.length === 1) {
      return true;
    }

    console.log(results[0].score, results[1].score);

    // 1stScore と 2ndStore の差が大きければ「自信あり」
    if (results[0].score - results[1].score > CONFIG.SCORE_THRESHOLD_LogicB_FirstSecondDiff) {
      return true;
    }
    // 差が小さければ「自信なし」
    return false;
  } catch (e) {
    console.debug(e);
    return false;
  }
}

function qPerfectMatching(results, question) {
  try {
    if (results.length < 1) {
      return -1;
    }

    let suffix;
    let count = 0;
    for (let i in results) {
      if (results[i].question === question) {
        suffix = i;
        count++;
      }
    }

    if (count === 1) {
      // 完全一致の質問が1件の場合のみQAの配列位置を返す
      return suffix;
    }

    return -1;
  } catch (e) {
    console.debug(e);
    return -1;
  }
}

CONFIG.SCORE_THRESHOLD_RULE = confidenceMeasureLogicB; // this function return if the answer is predicted with confidence or not
CONFIG.SCORE_THRESHOLD_LogicB_FirstSecondDiff = 0.4;
CONFIG.SCORE_THRESHOLD_FOR_SORRY = 0.5; // この値より小さければ、回答の一覧画面で SORRY.png を表示する。
CONFIG.Q_PERFECT_MATCHING = qPerfectMatching;

// Send mail related
CONFIG.INQUIRY_MAIL = !(process.env.REACT_APP_INQUIRY_MAIL === 'false');

// JWT CONFIG
CONFIG.JWT_AUTH_HEADER_PREFIX = 'JWT';
CONFIG.DISABLE_JWT = false; // set to be true can disable JWT.

// qa_paraphrase ON(true) or OFF(false)
CONFIG.ENABLE_QA_PARAPHRASE = false;

// inquiry button ON(true) or OFF(false)
CONFIG.DISPLAY_INQUIRY_BUTTON_ALWAYS = false;

// multi department flag for prediction
CONFIG.ENABLE_MULTI_DEPT = false;

// URL route
CONFIG.APP_ROUTE = '/f';
CONFIG.ENABLE_SHARE_BUTTON = false;
CONFIG.SHARE_URL = '/share/';
CONFIG.QA_SHARE = CONFIG.SHARE_URL + ':id';
CONFIG.NO_SHARE_QA_MESSAGE_IN_DEPT_SPECIFIC = '申し訳ございません。ご指定のデータは表示できません。';

// MultiDept UI
CONFIG.MULTI_DEPT_MESSAGE = 'どのお問い合わせでしょうか?';

// enable_inquiry ON(true) or OFF(false)
CONFIG.ENABLE_INQUIRY = true;

// ****************
// **** DESIGN ****
// ****************
let DESIGN = {};

const baseStaticUrl = CONFIG.BACKEND_SERVERURL + '/shuchi_static/customize_frontend/';
CONFIG.BASE_STATIC_URL = baseStaticUrl;

DESIGN.FRONT = (
  <Image
    src={baseStaticUrl + 'images/qa_front.png'}
    responsive="true"
    style={{marginLeft: 'auto', marginRight: 'auto'}}
  />
);
DESIGN.SORRY = (
  <Image src={baseStaticUrl + 'images/qa_character_sorry.png'} responsive="true" style={{display: 'inline-block'}} />
);
DESIGN.THANKYOU = (
  <Image src={baseStaticUrl + 'images/qa_character_thanks.png'} responsive="true" style={{display: 'inline-block'}} />
);
DESIGN.TRAIN = (
  <Image src={baseStaticUrl + 'images/qa_character_train.png'} responsive="true" style={{display: 'inline-block'}} />
);
DESIGN.DEFAULT = (
  <Image src={baseStaticUrl + 'images/qa_character_default.png'} responsive="true" style={{display: 'inline-block'}} />
);
DESIGN.THANKS = (
  <Image src={baseStaticUrl + 'images/qa_character_thanks.png'} responsive="true" style={{display: 'inline-block'}} />
);

// DESIGN.SITELINK = <a href="/about">このサイトについて</a>;
DESIGN.HELPLINK = (
  <a href="/help" target="_blank">
    使い方
  </a>
);
// DESIGN.ABOUTLINK = <a href="/about" target="_blank">About SHUCHI</a>;

DESIGN.JUMBOTRONBTNCOLOR = ''; // default
DESIGN.JUMBOTRONBKGDCOLOR = ''; // default
// DESIGN.VISIBILITY = "hidden";  // hide all components before finishing loading shuchi.js

DESIGN.FRONT_TITLE = 'WisTalk';

DESIGN.SORRY_MESSAGE = '該当する質問はありませんか？';
DESIGN.NO_CONFIDENCE_MESSAGE = '該当する質問は以下にありますか？';

DESIGN.ENABLE_QA_SHARE = false;
DESIGN.QA_SHARE_HEADER_BACKGROUND_COLOR = '#0041c0';
DESIGN.QA_SHARE_HEADER_COLOR = '#FFFFFF';
DESIGN.GUIDE_TO_CF = '';
DESIGN.SHARE_URL_BUTTON = (
  <Image src={baseStaticUrl + 'images/share_button.png'} responsive style={{display: 'inline-block'}} />
);
DESIGN.SHARE_BUTTON_PATH = baseStaticUrl + 'images/share_button.png';

// Chat related
DESIGN.CHATTITLE = 'WisTalk'; // title of chat window
DESIGN.CHATTITLECOLOR = '#4285F4'; // background color of chat window title
DESIGN.CHATBOTBUBBLECOLOR = '#4285F4'; // color of chat bot bubble
DESIGN.CHATAVATORURL = baseStaticUrl + 'images/chat_avatar.png';
DESIGN.CHATAVATOR2URL = baseStaticUrl + 'images/chat_avatar_detail_answer.png';

// CategoryGroup Hierarchy Graph
DESIGN.BUTTON_NOT_SELECT_CATEGORY_GROUP = '検索範囲を限定しない';

// 認証機能
CONFIG.REQURE_SOCIAL_LOGIN = false;

// ********************************************************************
// **** Update CONFIG and DESIGN Parameters according to DB ****
// ********************************************************************
let updateConfig = (callBackFunc) => {
  // API(/api/operation/setting_list)を呼び出してDBからデータを取得
  getSettingList(CONFIG.SERVERURL).done((data) => {
    data.forEach(function (item) {
      if (item.name === 'jumbotron_button_color' && item.value !== '') {
        DESIGN.JUMBOTRONBTNCOLOR = item.value;
        return;
      }
      if (item.name === 'jumbotron_background_color' && item.value !== '') {
        DESIGN.JUMBOTRONBKGDCOLOR = item.value;
        return;
      }
      if (item.name === 'enable_qa_paraphrase' && item.value != '') {
        CONFIG.ENABLE_QA_PARAPHRASE = item.value;
        return;
      }
      if (item.name === 'display_inquiry_button_always' && item.value !== '') {
        CONFIG.DISPLAY_INQUIRY_BUTTON_ALWAYS = item.value;
        return;
      }
      if (item.name === 'app_route' && item.value !== '') {
        CONFIG.APP_ROUTE = item.value;
        return;
      }
      if (item.name === 'score_threshold_logic_b_first_second_diff' && item.value !== '') {
        CONFIG.SCORE_THRESHOLD_LogicB_FirstSecondDiff = item.value;
        return;
      }
      if (item.name === 'score_threshold_for_sorry' && item.value !== '') {
        CONFIG.SCORE_THRESHOLD_FOR_SORRY = item.value;
        return;
      }
      if (item.name === 'disable_jwt' && item.value !== '') {
        CONFIG.DISABLE_JWT = item.value;
        return;
      }
      if (item.name === 'backend_server_url' && item.value !== '') {
        CONFIG.BACKEND_SERVERURL = item.value;
        return;
      }
      if (item.name === 'auth_server_url' && item.value !== '') {
        CONFIG.AUTH_SERVERURL = item.value;
        return;
      }
      if (item.name === 'site_link_url' && item.value !== '') {
        DESIGN.SITELINK = <a href={item.value}>このサイトについて</a>;
        return;
      }
      if (item.name === 'help_link_url' && item.value !== '') {
        DESIGN.HELPLINK = (
          <a href={item.value} target="_blank" rel="noreferrer">
            使い方
          </a>
        );
        return;
      }
      if (item.name === 'enable_multi_dept' && item.value !== '') {
        CONFIG.ENABLE_MULTI_DEPT = item.value;
        return;
      }
      if (item.name === 'find_button_not_select_category_group' && item.value !== '') {
        DESIGN.BUTTON_NOT_SELECT_CATEGORY_GROUP = item.value;
      }
      if (item.name === 'find_msg_ask_select_from_category_groups' && item.value !== '') {
        CONFIG.MULTI_DEPT_MESSAGE = item.value;
        return;
      }
      if (item.name === 'find_site_title' && item.value !== '') {
        DESIGN.FRONT_TITLE = item.value;
        return;
      }
      if (item.name === 'find_site_sorry_message' && item.value !== '') {
        DESIGN.SORRY_MESSAGE = item.value;
        return;
      }
      if (item.name === 'find_site_no_confidence_message' && item.value !== '') {
        DESIGN.NO_CONFIDENCE_MESSAGE = item.value;
        return;
      }
      if (item.name === 'require_social_login_to_user' && item.value === true) {
        CONFIG.SERVERURL = CONFIG.BACKEND_SERVERURL + '/c/backends';
        CONFIG.REQURE_SOCIAL_LOGIN = true;
      }
      if (item.name === 'enable_inquiry' && item.value !== '') {
        CONFIG.ENABLE_INQUIRY = item.value;
        return;
      }
      if (item.name === 'enable_qa_share' && item.value !== '') {
        CONFIG.ENABLE_SHARE_BUTTON = item.value;
        return;
      }
      if (item.name === 'guide_to_wistalk' && item.value !== '') {
        DESIGN.GUIDE_TO_CF = item.value;
        return;
      }
      if (item.name === 'qa_share_header_background_color' && item.value !== '') {
        DESIGN.QA_SHARE_HEADER_BACKGROUND_COLOR = item.value;
        return;
      }
      if (item.name === 'qa_share_header_color' && item.value !== '') {
        DESIGN.QA_SHARE_HEADER_COLOR = item.value;
        return;
      }
    });
    callBackFunc();
  });
};

export default CONFIG;
export {DESIGN, updateConfig};
